import { Pipe, type PipeTransform } from '@angular/core';
import { MeasurementUnit } from '../models';

@Pipe({ name: 'valueWithUnit' })
export class ValueWithUnitPipe implements PipeTransform {
    transform(value: number | string, unit: MeasurementUnit): number | string {
        if (value === undefined || value === null || value === '') {
            return '--';
        }

        return unit ? `${value} ${unit}` : value;
    }
}
